import { Route, Routes, Navigate } from "react-router-dom";
import HomePage from "pages/homePage";
import UserProfile from "pages/userProfile";
import SupplyAndDemand from "pages/supplyDemand";
import PropTypes from "prop-types";
import Emptystate from "components/emptyState";
import constants from "../constants/constants.json";
import UserManagementPanels from "pages/userManagementTabs/userManagementPanels";
import RolesSettings from "../components/rolesSettings";
import PermissionsSettings from "components/permissionsSettings";
import SmartRepair from "pages/smartRepair";

export const AppRoutes = ({ isNavbarOpen }) => {
  return (
    <Routes>
      <Route path={"/"} element={<HomePage isNavbarOpen={isNavbarOpen} />} />
      <Route
        path={"/profile"}
        element={<UserProfile isNavbarOpen={isNavbarOpen} />}
      />
      <Route
        path={"/smart-repair"}
        element={<SmartRepair isNavbarOpen={isNavbarOpen} />}
      />
      <Route
        path="/overview/entry/:pid/:fid?/:tid?/*"
        element={<SupplyAndDemand isNavbarOpen={isNavbarOpen} />}
      />
      <Route
        path="/usermanagement"
        element={<Navigate to="/usermanagement/users" replace />}
      />
      <Route
        path="/usermanagement/:id"
        element={<UserManagementPanels isNavbarOpen={isNavbarOpen} />}
      />
      <Route
        path="/usermanagement/roles/addrole"
        element={<RolesSettings isNavbarOpen={isNavbarOpen} />}
      />
      <Route
        path="/usermanagement/roles/editrole"
        element={<RolesSettings isNavbarOpen={isNavbarOpen} />}
      />
      <Route
        path="/usermanagement/permissions/addpermission"
        element={<PermissionsSettings isNavbarOpen={isNavbarOpen} />}
      />
      <Route
        path="/usermanagement/permissions/editpermission"
        element={<PermissionsSettings isNavbarOpen={isNavbarOpen} />}
      />
      <Route
        path="/forbidden"
        element={
          <Emptystate
            title={constants.forbidden}
            message={constants.unauthorizedMessage}
            isNavbarOpen={isNavbarOpen}
            isErrorPage
          />
        }
      />
      <Route
        path="/unauthorized"
        element={
          <Emptystate
            title={constants.unauthorized}
            message={constants.unauthorizedMessage}
            isNavbarOpen={isNavbarOpen}
            isErrorPage
          />
        }
      />
      <Route
        path="/notfound"
        element={
          <Emptystate
            title={constants.notFound}
            message={constants.notFoundMessage}
            isNavbarOpen={isNavbarOpen}
            isErrorPage
          />
        }
      />
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
};

AppRoutes.propTypes = {
  isNavbarOpen: PropTypes.bool,
};
